














































import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import MarketplaceOrderStatusBadge from '~/components/car/marketplace/order/MarketplaceOrderStatusBadge.vue'
import CMultiThumb from '~/components/shared/configurable/image/CMultiThumb.vue'
import { Order } from '~/models/marketplace/order'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'

export default defineComponent({
  components: { CMultiThumb, MarketplaceOrderStatusBadge },
  props: {
    order: {
      type: Object as PropType<Order>,
      required: true
    }
  },
  setup(props) {
    const { order } = toRefs(props)
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)

    const isSeller = computed(() => {
      return userGetters('marketplaceSellerId') === order.value.seller.id
    })

    return {
      isSeller
    }
  }
})
